  <template>
    <div class="control-section">
    <div  class="h100vh-140">
        <ejs-grid ref='grid' :dataSource="data" height='calc(100% - 0px)' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='66' textAlign='Center' minWidth='10px'></e-column>
            <e-column field='supi' :headerText='$t("Supi.supi")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='gpsi' :headerText='$t("Supi.gpsi")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='userSubProfileId' :headerText='$t("Supi.userSubProfileId")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <!-- <e-column field='ipv4Addr' :headerText='$t("Supi.ipv4Addr")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='ipv6Addr' :headerText='$t("Supi.ipv6Addr")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column> -->
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='qryUsers()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <CustomDialog ref='addUserPage' :element='dialog.element.eleAddUser' :styles='dialog.styles' :messages='dialog.messages.addUser'>
        <template v-slot:dialog-content>
          <AddUserForm ref="addUser" ></AddUserForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='addBatchUserPage' :element='dialog.element.eleAddBatchUser' :styles='dialog.styles' :messages='dialog.messages.addBatchUser'>
        <template v-slot:dialog-content>
          <AddBatchUserForm ref="addBatchUser" ></AddBatchUserForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='modUserPage' :element='dialog.element.eleModUser' :styles='dialog.styles' :messages='dialog.messages.modUser'>
        <template v-slot:dialog-content>
          <ModUserForm ref="modUser" ></ModUserForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='delRangePage' :element='dialog.element.eleDelRange' :styles='dialog.stylesDelRange' :messages='dialog.messages.delRange'>
        <template v-slot:dialog-content>
          <DelRangeUserForm ref="delRange" ></DelRangeUserForm>
        </template>
      </CustomDialog>
      <Notification ref='notification' :position='position' timeOut='2000' ></Notification>
      <DialogConfirm ref='dialogConfirm' :title='$t("Common.confirm")' :content='$t("LteUser.delConfirm")' :onOk='onClickDelOk' ></DialogConfirm>
      <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
    </div>
  </template>
<script>

import { Reorder, Resize } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../../common/CustomDialog';
import Notification from "../../util/tipDialog/Notification";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddUserForm from './dialog/AddUserForm';
import AddBatchUserForm from './dialog/AddBatchUserForm';
import ModUserForm from './dialog/ModUserForm';
import DelRangeUserForm from './dialog/DelRangeUserForm';
import ajaxUrl from "../../data/ajaxUrl";
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: 'SupiTable',
  components: {
    CustomDialog,
    Notification,
    DialogConfirm,
    AddUserForm,
    AddBatchUserForm,
    ModUserForm,
    DelRangeUserForm,
    DialogList,
  },
  data() {
    return {
      data: {},
      qryTypeFlag: 0,
      filterFlag: false,
      imsiFilter: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0,
      },
      ne: {
        neid: '',
        netype: '',
        neversion: '',
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          visible: false,
          model: true,
        },
        stylesDelRange: {
          width: '810px',
          height: 'auto',
          visible: false,
          model: true,
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddUser: {
            target: this.$refs.addUser,
            refName: 'eleAddUser',
            buttonGroup: [
              { click: this.saveAddUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } },
              { click: this.closeAddUserPage, buttonModel: { content: this.$t("LteUser.cancel") } }
            ],
            title: this.$t("LteUser.addUser"),
            isClose: true,
          },
          eleAddBatchUser: {
            target: this.$refs.addBatchUser,
            refName: 'eleAddBatchUser',
            buttonGroup: [
              { click: this.saveAddBatchUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } },
              { click: this.closeAddBatchUserPage, buttonModel: { content: this.$t("LteUser.cancel") } }
            ],
            title: this.$t("LteUser.addBatchUser"),
            isClose: true,
          },
          eleModUser: {
            target: this.$refs.modUser,
            refName: 'eleModUser',
            buttonGroup: [
              { click: this.saveModUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } },
              { click: this.closeModUserPage, buttonModel: { content: this.$t("LteUser.cancel") } }
            ],
            title: this.$t("LteUser.modUser"),
            isClose: true,
          },
          eleDelRange: {
            target: this.$refs.delRange,
            refName: 'eleDelRange',
            buttonGroup: [
              { click: this.saveDelRangeUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } },
              { click: this.closeDelRangePage, buttonModel: { content: this.$t("LteUser.cancel") } }
            ],
            title: this.$t("LteUser.delRange"),
            isClose: true,
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("LteUser.confirm") }
              }
            ],
            title: this.$t("LteUser.logger"),
            isClose: true,
          },
        },
        messages: {
          addUser: {
            title: this.$t("LteUser.addUser"),
          },
          addBatchUser: {
            title: this.$t("LteUser.addBatchUser"),
          },
          modUser: {
            title: this.$t("LteUser.modUser"),
          },
          delRange: {
            title: this.$t("LteUser.delRange"),
          },
        },
      },
      position: { X: 'Center', Y: 'Top' },
      imsiFilter: '',
       descCommonError: {
        0: this.$t("DNN.commonError0"),
        1: this.$t("DNN.commonError1"),
        2: this.$t("DNN.commonError2"),
        3: this.$t("DNN.commonError3"),
        4: this.$t("DNN.commonError4"),
        5: this.$t("DNN.commonError5"),
        6: this.$t("DNN.commonError6"),
        7: this.$t("DNN.commonError7"),
        8: this.$t("DNN.commonError8"),
        9: this.$t("DNN.commonError9"),
        10: this.$t("DNN.commonError10"),
        11: this.$t("DNN.commonError11"),
        12: this.$t("DNN.commonError12"),
        13: this.$t("DNN.commonError13"),
        14: this.$t("DNN.commonError14"),
        15: this.$t("DNN.commonError15"),
      },

    };
  },
  provide: {
      grid: [ Reorder, Resize ],
  },
  methods: {
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryUsers();
    },
    isChooseNe() {
      if (this.ne.neid === '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.pleaseSelectNE")});
        return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("PDN.pleaseSelectDatas")});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("PDN.pleaseSelectOneData")});
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const userId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        userId.push(checkedData[i].supi);
      }
      return userId.length === 0 ? false : userId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      if (0!==response.data.resultVal.result) {
        EventBus.$emit('toast', {type: 'warning', 
          content: response.data.errorString
        });
        return true;
      }
      return false;
    },
    openAddUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addUser.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
          return;
        }
        this.$refs.addUserPage.show();
      });
    },
    closeAddUserPage() {
      this.$refs.addUserPage.clear();
      this.$refs.addUserPage.close();
    },
    saveAddUser() {
      this.$refs.addUser.saveUser(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddUserPage();
        EventBus.$emit('toast', {type: 'success', content: this.$t("Supi.addProfileSuccess")});
        this.qryUsers();
      });
    },
    getKey(obj, value) {
      for(let key in obj){
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
    openModUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
         const record = checkedDatas.map((item) => {
          return {
            ...item,
          }
        });
        this.$refs.modUser.getJson(this.ne, record, (response) => {
          if(response.data.errorCode !== "0") {
            EventBus.$emit('toast', {type: 'warning', content: response.data.errorString });
            return;
          }
          this.$refs.modUserPage.show();
        });
      }
    },
    closeModUserPage() {
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },
    saveModUser() {
      this.$refs.modUser.saveUser(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeModUserPage();
        EventBus.$emit('toast', {type: 'success', content: this.$t("Supi.modProfileSuccess")});
        this.qryUsers();
      });
    },
    delUsers() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      console.log("delKeys",delKeys)
      const params = {
        vo: {
          startSupi: "",
          count: 0,//随意写
          bitmask: 1,
          supiList:delKeys,
        },
        info: {
          msgid: "28694",
          neid: this.ne.neid,
        }
      };

      this.$axios.post(ajaxUrl.delCommonD, params).then(response => {
        if (!response) {
          console.log("onClickDelOk response error");
          return;
        }
        if (!response.data) {
          console.log("onClickDelOk response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("onClickDelOk response.data.resultVal null error");
          return;
        }
        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < delKeys.length; i++) {
          operList.push({
            operObj: delKeys[i],
            operResult: resultCodeStr[i],
            operCode:resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delKeys.length);
        this.$refs.dialogListPage.show();
        this.qryUsers(undefined,undefined,true);
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    refreshData() {
      this.imsiFilter = '';
      this.filterFlag = false;
      this.qryUsers(0, true);
    },
    filterData() {
      this.filterFlag = true;
      this.qryUsers(1, true);
    },
    qryUsers(flag = undefined, prompt=false,delFlag = false) {
     if (flag === undefined) {
        flag = this.qryTypeFlag;
      } 
      else if (flag === 1 &&''===this.imsiFilter) {//输入了不填写点击搜索按钮
        flag = 0;
        this.qryTypeFlag = 0;
      }
      else {
        this.qryTypeFlag = flag;
      }
      this.page.pageNo = this.filterFlag ? 1 : this.$refs.pager.ej2Instances.currentPage;
      if (delFlag) {
         this.page.pageNo = 1;
      }
      this.filterFlag = false;      
      const params = {
        vo: {
          flag: flag,
          supi: (flag === 1) ? this.imsiFilter : '',
        },
        info: {
          msgid: "28695",
          neid: this.ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };
      this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
        if (!response) {
          console.log("qryUsers response error");
          return;
        }
        if (!response.data) {
          console.log("qryUsers response.data error");
          return;
        }
        if (response.data.errorCode ===  'subscriber.9005') {
          this.ne.neid = '';
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          EventBus.$emit('toast', {type: 'warning', content: this.$t('MCS.neOffLine')});
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryUsers response.data.resultVal error");
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          return;
        }
        if (response.data.resultVal.result !== 0 && response.data.resultVal.result !== 1 ) {
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          console.log("qryUsers response.data.resultVal.result error");
          return;
        }
        const res = response.data.resultVal;
        if (res) {
          if (res.supiProfileInfo) {
            const supiProfileInfo = res.supiProfileInfo.map(item => {
              return {
                ...item,
              }
            });
            this.data = supiProfileInfo;
          } else {
            this.data = [];
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countRsp;
          this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }
      });
    },
    openAddBatchUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addBatchUser.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString });
          return;
        }
        this.$refs.addBatchUserPage.show();
      });
    },
    closeAddBatchUserPage() {
      this.$refs.addBatchUserPage.clear();
      this.$refs.addBatchUserPage.close();
    },
    saveAddBatchUser() {     
      this.$loading.showLoadding(this.$t('LteUser.batchAddUserTip'),this.$t('SubscriberIms.waitTip'));
      this.$refs.addBatchUser.saveBatchUser(this.ne, (response, addUserList) => {
        if (this.responseIsFailed(response)) {
          this.$loading.hideLoadding();
          return;
        }
        this.closeAddBatchUserPage();
        this.$loading.hideLoadding();

         if (!response) {
          console.log("saveBatchUser response error");
          return;
        }
        if (!response.data) {
          console.log("saveBatchUser response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("saveBatchUser response.data.resultVal error");
          return;
        }
        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < addUserList.length; i++) {
          operList.push({
            operObj: addUserList[i].supi,
            operResult: resultCodeStr[i],
            operCode:resultVal[i]
          });
        }
        console.log("operList",operList)
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(addUserList.length);
        this.$refs.dialogListPage.show();
        this.qryUsers();
      });

    },
    openDelRangePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.delRangePage.show();
    },
    closeDelRangePage() {
      this.$refs.delRangePage.clear();
      this.$refs.delRangePage.close();
    },
    saveDelRangeUser() {     
      this.$loading.showLoadding(this.$t('LteUser.batchDelUserTip'),this.$t('SubscriberIms.waitTip'));
      this.$refs.delRange.delRangeUser(this.ne, (response,delUserList) => {
        if (this.responseIsFailed(response)) {
          this.$loading.hideLoadding();
          return;
        }
        this.closeDelRangePage();
        this.$loading.hideLoadding();

       const resultVal = response.data.resultVal.resultCode;
       const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < delUserList.length; i++) {
          operList.push({
            operObj: delUserList[i].startSupi,
            operResult: resultCodeStr[i],
            operCode:resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delUserList.length);

        this.$refs.dialogListPage.show();
        this.qryUsers(undefined,undefined,true);
      });

    },
    setfilter(params) {
      this.imsiFilter = params;
    },
  }
};
</script>

<style scoped>

</style>
